export default __webpack_public_path__ + "static/media/chef.211e6c65.png";